﻿import { createFileRoute } from "@tanstack/react-router";
import { AlterarSenhaPage } from "@/paginas/pg_usuarios/usuarios-perfil-alterar-senha";

export const Route = createFileRoute("/_authenticated/usuarios-perfil-alterar-senha")({
  head: () => ({
    meta: [
      { title: "Alterar senha — Milky Moo Palmares" },
      {
        name: "description",
        content: "Troque a senha da sua conta de acesso informando a senha atual e a nova senha.",
      },
      { property: "og:title", content: "Alterar senha — Milky Moo Palmares" },
      {
        property: "og:description",
        content: "Troca de senha da conta de acesso do sistema.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: AlterarSenhaPage,
});
